import { useAtom, useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import {
    artistSearchKeywordAtom,
    filterModalStateAtom,
    placeSearchKeywordAtom,
    searchKeywordAtom,
    topPageEventListObjectAtom,
} from "../event.atom";
import type { TopPageFilterModalProps } from "../components/TopPageFilterModal/TopPageFilterModal";

const useTopPageFilterModal = (props: TopPageFilterModalProps) => {
    const [searchKeyword, setSearchKeyword] = useAtom(searchKeywordAtom);

    const isFirstRender = useRef(true);

    const [filterModalState, setFilterModalState] =
        useAtom(filterModalStateAtom);

    const [artistSearchKeyword, setArtistSearchKeyword] = useAtom(
        artistSearchKeywordAtom
    );

    const [placeSearchKeyword, setPlaceSearchKeyword] = useAtom(
        placeSearchKeywordAtom
    );

    const setTopPageEventListObject = useSetAtom(topPageEventListObjectAtom);

    const handelCloseModal = () => {
        props.setModalOpen(false);
    };

    const handelApply = () => {
        props.setModalOpen(false);
        setFilterModalState(true);
    };

    const handelCancel = () => {
        props.setModalOpen(false);
        setFilterModalState(false);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setTopPageEventListObject(true);
    }, [setTopPageEventListObject, filterModalState]);

    return {
        searchKeyword,
        setSearchKeyword,
        artistSearchKeyword,
        setArtistSearchKeyword,
        placeSearchKeyword,
        setPlaceSearchKeyword,
        handelCloseModal,
        handelApply,
        handelCancel,
    };
};

export default useTopPageFilterModal;
